export const DATA_QA_PSEUDO_INPUT_CLEAR = 'pseudo-input-clear-button';
export const DATA_QA_SEARCH_INPUT = 'search-input';
export const DATA_QA_DIVIDER = 'divider';
